import React, { ChangeEvent, FC, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClickAwayListener, Tabs, Unstable_Grid2 as Grid } from '@mui/material';

import { ClientInvitationSearchFilter, ClientInvitationStatus } from 'api';
import { UseCheckedState } from 'types/app';
import { LargeTab, Search } from 'components';
import theme from 'theme';

const styles = {
  root: {
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    paddingRight: 2,
  },
} as const;

interface Props extends Partial<UseCheckedState> {
  searchFilter: ClientInvitationSearchFilter;
  onSetSearchFilter: (searchFilter: ClientInvitationSearchFilter) => void;
  actions: ReactNode;
}

const TableHeader: FC<Props> = ({ searchFilter, onSetSearchFilter, hasChecked, actions }) => {
  const { t } = useTranslation();
  const [searchFocused, setSearchFocused] = useState(false);

  function handleTabChange(event: ChangeEvent, value: ClientInvitationStatus) {
    onSetSearchFilter({
      ...searchFilter,
      invitation_status__eq: value,
    });
  }

  function handleQueryChange(query: string) {
    onSetSearchFilter({ ...searchFilter, query });
  }

  function renderSearch() {
    return (
      <ClickAwayListener onClickAway={() => setSearchFocused(false)}>
        <Search
          query={searchFilter.query}
          focused={searchFocused}
          onChange={(event: ChangeEvent<HTMLInputElement>) => handleQueryChange(event.target.value)}
          onClear={() => handleQueryChange('')}
          onFocus={() => setSearchFocused(true)}
        />
      </ClickAwayListener>
    );
  }

  return (
    <Grid container justifyContent="space-between" alignItems="center" sx={styles.root}>
      <Grid>
        <Tabs value={searchFilter.invitation_status__eq} onChange={handleTabChange}>
          <LargeTab label={t('common:pending')} value={ClientInvitationStatus.Active} />
          <LargeTab label={t('common:accepted')} value={ClientInvitationStatus.Accepted} />
        </Tabs>
      </Grid>
      <Grid>
        <Grid>{hasChecked ? actions : renderSearch()}</Grid>
      </Grid>
    </Grid>
  );
};

export default TableHeader;
